import React, { useState, useEffect } from "react";
import RegistrarObra from "./modalRegistrarObras";
import { Mensaje } from "../mensajes2";

import { Dimmer } from "../spinner";

import useTable from "../useTable3";
import axios from "axios";
import { Toasts } from "../toasts";
import { SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";
import { formatMoneda } from "../../util/varios";

function TablaObras(props) {
    let token = localStorage.getItem("jwtToken");
    let op = require("../../../src/modulos/datos");
    const anioactu = JSON.parse(localStorage.getItem("anioactu"));
    const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

    const [titulo, setTitulo] = useState();
    const [index, setIndex] = useState()
    const [msg, setMsg] = useState();
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [idObra, setIdObra] = useState(0);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [obra, setObra] = useState();
    const [statusCome, setStatusCome] = useState();
    const [configCome, setConfigCome] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [deuda, setDeuda] = useState();
    const [historico, setHistorico] = useState();
    const [pagow, setPagow] = useState();
    const [retencion, setRetencion] = useState();
    const [multas, setMultas] = useState();
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [facturasPagadas, setFacturasPagadas] = useState();
    const [facturasPagadasEtax, setFacturasPagadasEtax] = useState();

    const [facturasOtrosPgosEtax, setFacturasOtrosPgosEtax] = useState();

    const [factorCambio, setFactorCambio] = useState(0);

    const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
    const [fechaSistema, setFechaSistema] = useState(
        localStorage.getItem("fechasistema")
    );
    const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
    const [deshabilitado, setDeshabilitado] = useState(false);
    const permiso = JSON.parse(localStorage.getItem("acccontribuyente"));
    const [permisoDecla, setPermisoDecla] = useState();
    const [permisoExon, setPermisoExon] = useState();
    const [records, setRecords] = useState([]);
    const [sigue, setSigue] = useState(false);
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: "",
        titulo: "",
    });

    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });

    const headCells = [
        {
            id: "idobra",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "CODIGO",
            textAlign: "center",
            width: "80px",
        },
        {
            id: "descripcion",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "OBRA",
            textAlign: "center",
            width: "350px",
        },
        {
            id: "tipo",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "TIPO",
            textAlign: "center",
            width: "80px",
        },
        {
            id: "monto",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "MONTO",
            textAlign: "center",
            width: "150px",
        },
        {
            id: "opciones",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: " OPCIONES",
            textAlign: "center",

        },
    ];

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
        useTable(records, headCells, filterFn);

    const handleSearch = (e) => {
        let target = e.target;

        setFilterFn({
            fn: (items) => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter((x) => {
                        if (
                            (x.idobra.includes(target.value) === null
                                ? ""
                                : x.idobra.includes(target.value)) ||
                            (x.descripcion === null
                                ? ""
                                : x.descripcion.toLowerCase().includes(target.value.toLowerCase())) ||
                            (x.tipoobra === null
                                ? ""
                                : x.tipoobra.toLowerCase().includes(target.value.toLowerCase())) ||
                            (x.monto === null
                                ? ""
                                : formatMoneda(x.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2).includes(target.value))
                        ) {
                            return x;
                        }
                    });
                }
            },
        });
    };

    const seleccionarObras = () => {
        setActivate(true);
        setRecords([]);

        let endpoint = `${op.conexion}/api/ingenieria/seleccionarregistroobras?idefiscal=${idefiscal}&espiritu=${espiritu}`;
        //let endpoint = `${op.conexion}/api/industria/comercios`;

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.length > 0) {
                        setRecords(response.data);
                        console.log(response.data);
                    }
                }

                setActivate(false);
            })
            .catch((error) => {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });
                console.log(error)
                setActivate(false);
            });
    };
    
    const SelectObra = (idobra, index) => {
        //alert(idobra)
        let endpoint = `${op.conexion}/api/ingenieria/seleccionarobras/${idobra}`;

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then((response) => {
                if (response.status == 200) {
                    setObra(response.data);
                    setMostrar5(true);
                }
                setActivate(false)
            })
            .catch((error) => {
                /*  setMensaje({
                   mostrar: true,
                   titulo: "ERROR",
                   texto: error.response.data.message,
                   icono: "error",
                 }); */
                console.log(error)
            });
    };
    
    const agregarObra = (permiso) => (e) => {
        e.preventDefault();
        if (permiso === "1") {
            setOperacion(1);
            setObra();
            setDeshabilitado(false);
            setMostrar5(true);
        } else {
            setToast({
                mostrar: true,
                titulo: "Notificación",
                mensaje:
                    "No posee permiso para registrar una Obra",
            });
        }
    };

    const cerrarModalActualizar = () => {
        setObra();
        setMostrar5(false);
        seleccionarObras();
    };

    const validarActuComercio = () => {
        if (operacion === 4) {
            setObra();
            setMostrar5(false);
            return;
        }
        if (operacion === 1) {
            setIdObra(0);
        }

        setObra();
        setMostrar5(false);
        renderizar();
    };

    const handleCloseMensa = () => {
        setMostrar(false);
    };

    const renderizar = () => {
        seleccionarObras();
    };

    const consultarObra = (id, index, permiso) => (event) => {
        event.preventDefault();
        //setIndex(index.rif)
        if (permiso === "1") {
            setDeshabilitado(true);
            setIdObra(id);
            setActivate(true);
            SelectObra(id, index);
            setOperacion(4);
        } else {
            setToast({
                mostrar: true,
                titulo: "Notificación",
                mensaje:
                    "No posee permiso para consultar una Obra",
            });
        }
    };

    const editarObra = (id, index, permiso) => (event) => {
        event.preventDefault();
        //setIndex(index.rif)

        if (permiso === "1") {
            setOperacion(2);
            setDeshabilitado(false);
            setIdObra(id);
            setActivate(true);
            SelectObra(id, index);
        } else {
            setToast({
                mostrar: true,
                titulo: "Notificación",
                mensaje:
                    "No posee permiso para editar una Obra",
            });
        }
    };

    const eliminarObra = (id, index, permiso) => (event) => {
        event.preventDefault();
        //setIndex(index.rif)
        if (permiso === "1") {
            setOperacion(3);
            setDeshabilitado(true);
            setIdObra(id);
            setActivate(true);
            SelectObra(id, index);
        } else {
            setToast({
                mostrar: true,
                titulo: "Notificación",
                mensaje:
                    "No posee permiso para eliminar una Obra",
            });
        }
    };

    const seleccionarFactorCambio = () => {
        let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    setFactorCambio(response.data.valor);
                }
            })
            .catch(function (error) {
                /*  setMensaje({
                   mostrar: true,
                   titulo: "ERROR",
                   texto: error.response.data.message,
                   icono: "error",
                 }); */
                console.log(error)
            });
    };

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem("post"));

        seleccionarFactorCambio();
        setPermisoDecla(JSON.parse(localStorage.getItem("permisos")).accpermdecla);
        setPermisoExon(
            JSON.parse(localStorage.getItem("permisos")).accexoncomercio
        );
        setFechaSistema(obj.fechasistema);
        setIdUsuario(obj.idusuario);
        setEspiritu(obj.espiritu);

        seleccionarObras();
    }, []);

    const cerrarToast = () => {
        setToast({
            ...toast,
            mostrar: false,
        });
    };

    const cerrar = () => {
        props.setTabla(0);
    };

    return (
        <div className="col-10 mx-auto m-0 p-2 border rounded">

            <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
                <div className="col-3 m-0 p-0">
                    <SearchInput
                        onChange={handleSearch}
                        placeholder="Buscar"
                    />
                </div>
                <div className="col-auto m-0 p-0">
                    <PrimaryButton icon='fa-plus m-0'
                        onClick={agregarObra(
                            permiso.toString().substring(1, 2)
                        )}
                        disabled={permiso.toString().substring(1, 2) !== "1"}
                    >
                    </PrimaryButton>
                </div>
            </div>
            <div className="col-12 m-0 p-0" >
                <TblContainer >
                    <TblHead />
                    <tbody  >
                        {records &&
                            recordsAfterPagingAndSorting().map((item, index) => (
                                <tr
                                    key={item.idobra}
                                    style={{ padding: "0" }}
                                >
                                    <td
                                        className="align-baseline"
                                        style={{
                                            textAlign: "center",
                                            width: "80px",
                                        }}
                                    >
                                        {item.idobra}
                                    </td>
                                    <td
                                        className="align-baseline"
                                        style={{
                                            textAlign: "center",
                                            width: "350px",
                                        }}
                                    >
                                        {item.descripcion}
                                    </td>
                                    <td
                                        className="align-baseline"
                                        style={{
                                            textAlign: "center",
                                            width: "80px",
                                        }}

                                    >
                                        {item.tipoobra}
                                    </td>
                                    <td
                                        className="align-baseline"
                                        style={{
                                            textAlign: "right",
                                            width: "150px",
                                        }}

                                    >
                                        {formatMoneda(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)}
                                    </td>
                                    <td
                                        className="align-baseline text-center"
                                        style={{ width: '150px' }}


                                    >
                                        <button
                                            onClick={consultarObra(
                                                item.idobra,
                                                item,
                                                permiso.toString().substring(0, 1)
                                            )}
                                            title="Consultar Contribuyente"
                                            className={
                                                permiso.toString().substring(0, 1) === "1"
                                                    ? "btn btn-sm btn-info rounded-pill"
                                                    : "btn btn-sm btn-secondary rounded-pill"
                                            }
                                        >
                                            <i className="fas fa-eye"></i>
                                        </button>
                                        <a> &nbsp; </a>
                                        <button
                                            onClick={editarObra(
                                                item.idobra,
                                                item,
                                                permiso.toString().substring(2, 3)
                                            )}
                                            title="Editar Con"
                                            className={
                                                permiso.toString().substring(2, 3) === "1"
                                                    ? "btn btn-sm btn-warning rounded-pill"
                                                    : "btn btn-sm btn-secondary rounded-pill"
                                            }
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                        <a> &nbsp; </a>
                                        <button
                                            onClick={eliminarObra(
                                                item.idobra,
                                                item,
                                                permiso.toString().substring(3, 4)
                                            )}
                                            className={
                                                permiso.toString().substring(3, 4) === "1"
                                                    ? "btn btn-sm btn-danger rounded-pill"
                                                    : "btn btn-sm btn-secondary rounded-pill"
                                            }
                                        >
                                            <i className="fa fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>
            <RegistrarObra
                show={mostrar5}
                factorCambio={factorCambio}
                onHideCancela={cerrarModalActualizar}
                onHideAcepta={validarActuComercio}
                obra={obra}
                statuscome={statusCome}
                tabdeuda={deuda}
                tabpago={historico}
                tabpagow={pagow}
                tabmulta={multas}
                tabreten={retencion}
                deshabilitado={deshabilitado ? deshabilitado : undefined}
                ingresa={0}
                declaweb={configCome ? configCome.declaweb.toString() : "false"}
                idusuario={idUsuario}
                operacion={operacion}
                permisodecla={permisoDecla}
                permisoexon={permisoExon}
                factpago={facturasPagadas}
                factpagoetax={facturasPagadasEtax}
                factotropagoetax={facturasOtrosPgosEtax}

            />
            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
                }}
            />
            <Dimmer active={activate} inverted>
            </Dimmer>
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}
            />
        </div>
    );
}

export default TablaObras;
